module.exports = __webpack_public_path__ + "static/media/spiffy.f25d80ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/spiffy.png
// module id = 1832
// module chunks = 0